// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SpacesView_Wrapper__3IvlN","Description":"SpacesView_Description__1NYIs","Action":"SpacesView_Action__2VfVm"};